export enum FeedSubRoutes {
  FEED = '/',
  FEED_ALL = '/all',
  FEED_LIST = '/:postType',
  FEED_POST = '/:postType/:postId',
}
